import { cn } from "@/lib/utils";

export type Pillar = "finance" | "economics" | "entrepreneurship";

export const PILLAR_META: Record<
  Pillar,
  { label: string; instructor: string; tone: string; chip: string }
> = {
  finance: {
    label: "Finance",
    instructor: "Aelyra",
    tone: "text-primary",
    chip: "bg-primary/10 text-primary border-primary/30",
  },
  economics: {
    label: "Economics",
    instructor: "Caelion Veyr",
    tone: "text-accent",
    chip: "bg-accent/10 text-accent border-accent/30",
  },
  entrepreneurship: {
    label: "Entrepreneurship",
    instructor: "Headmaster Vaelor",
    tone: "text-secondary",
    chip: "bg-secondary/10 text-secondary-foreground border-secondary/30",
  },
};

/**
 * Map a course name to one of the three pillars. Falls back to "finance".
 * Used by Roadmap to group courses by pillar.
 */
export function getCoursePillar(courseName: string): Pillar {
  const n = courseName.toLowerCase();
  if (
    /econom|market|inflation|supply|demand|incentive|policy|case study/.test(n)
  ) {
    return "economics";
  }
  if (
    /entrepreneur|business|startup|ownership|leadership|career|real estate|wealth|legacy|venture/.test(
      n,
    )
  ) {
    return "entrepreneurship";
  }
  return "finance";
}

interface PillarBadgeProps {
  pillar: Pillar;
  showInstructor?: boolean;
  className?: string;
}

export default function PillarBadge({
  pillar,
  showInstructor,
  className,
}: PillarBadgeProps) {
  const meta = PILLAR_META[pillar];
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full border px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wider",
        meta.chip,
        className,
      )}
    >
      <span className="w-1.5 h-1.5 rounded-full bg-current opacity-80" />
      {meta.label}
      {showInstructor && (
        <span className="opacity-70 normal-case font-medium tracking-normal">
          · {meta.instructor}
        </span>
      )}
    </span>
  );
}